<template>
  <div>
      <el-dialog :visible.sync="showmodal" width="35%" @close="$emit('close-modal')">
          <div class="text-center modals-wrapper">
              <img src="@/assets/images/icons/putonhold-modal-icon.png" class="mt-10 mx-auto">
              <p class="mt-10 text-base">Kindly confirm you want to keep this package on hold</p>

              <button @click="putonHold" class="mt-12 rounded-md p-3 px-4 text-md">Confirm</button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showmodal: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async putonHold(){

        this.$emit('refetch-dispatch')
        this.$emit('show-final-hold')
        this.$emit('close-modal')
    },
    async pauseDispatch() {
      this.loading = true;
    },
    closeModal() {
      this.$emit("close-modal");
    }
  },
};
</script>

<style lang="scss" scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
}
.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
.modals-wrapper{
    button{
        background-color : #FCC210;
        color : #10233E;
        font-weight : 600;
    }
}
</style>
